module.exports = __webpack_public_path__ + "img/educational-qualifications.5ff50a81.svg";